'use strict'

const fontMetaData = require('./fontMetaData')
const fontUtils = require('./fontUtils')

module.exports = fontUtils(fontMetaData)



// WEBPACK FOOTER //
// ./src/coreUtils/src/main/fonts/fonts.js